import React from 'react';
import { Plus } from 'lucide-react';

interface AddNewButtonProps {
  onClick: () => void;
  variant?: 'primary' | 'secondary';
  label?: string;
}

const AddNewButton: React.FC<AddNewButtonProps> = ({
  onClick,
  variant = 'primary',
  label = 'Add New',
}) => {
  const baseClasses =
    'inline-flex items-center justify-center h-10 gap-2 px-6 text-sm font-medium tracking-wide transition duration-300 rounded focus-visible:outline-none whitespace-nowrap cursor-pointer disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-300 disabled:shadow-none';

  const variantClasses = {
    primary:
      'bg-primary text-white hover:bg-opacity-90 dark:bg-seam dark:text-cream dark:hover:bg-seam',
    secondary:
      'border border-secondary text-priamry bg-white hover:bg-secondary hover:text-white dark:border-seam dark:bg-charcoal dark:text-cream dark:hover:bg-seam dark:hover:text-white',
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]}`}
    >
      <span className="order-2">{label}</span>
      <span className="relative">
        <Plus
          className="w-5 h-5"
          aria-hidden="true"
          role="graphics-symbol"
          aria-label="Add Icon"
        />
      </span>
    </button>
  );
};

export default AddNewButton;
